import { InputHTMLAttributes, forwardRef } from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';

type Variant = 'error' | 'fit' | 'suggest' | 'right' | 'with-button';
type Props = {
  variants?: Variant[];
  autoComplete?: string;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'className' | 'style'>;
const Input = forwardRef<HTMLInputElement, Props>(
  ({ variants = [], autoComplete = 'none', ...props }, ref) => {
    const inputClassNames = classNames(
      styles.input,
      ...variants.map((v) => styles[v])
    );
    return (
      <input
        className={inputClassNames}
        {...props}
        ref={ref}
        autoComplete={autoComplete}
      />
    );
  }
);
Input.displayName = 'Input';
export default Input;
